import React from 'react'
import { Stack } from 'react-bootstrap'
import type { ShortcutConfig } from '@ztechapps/webui.util'
import { blogPermissions } from '@ztechapps/blog.common'
import { Page } from '@ztechapps/webui.page'
import { HorizontalStack } from '@ztechapps/webui.util'
import { BlogListProvider } from './Context'
import { Layout } from './Layout'
import { Toolbox } from './Toolbox'
import styles from './BlogCategoryTreeView/BlogCategoryTreeView.module.scss'

export type BlogListProps = {
  /** The host's Refresh shortcut entry — registered against the list's refetch. */
  refreshShortcut: ShortcutConfig
  /** The blog categories carry no tenant id (Payroll), so the tree checks the tenant-free reserved pair. */
  tenantFree?: boolean
}

export const BlogList = ({ refreshShortcut, tenantFree = false }: BlogListProps) => (
  <BlogListProvider tenantFree={tenantFree}>
    <Page roleName={blogPermissions.canView.value}>
      {/* The list fills the height its host gives it: the toolbar keeps its height and the region below it takes the
          rest, so the table, grid or tree scrolls inside that region and never drags the toolbar with it. A flex item
          refuses to shrink below its content unless its minimum height is cleared. */}
      <Stack gap={3} className={styles.shrinkable}>
        <HorizontalStack gap={2} className="flex-shrink-0">
          <Toolbox refreshShortcut={refreshShortcut} />
        </HorizontalStack>
        <div className={`${styles.shrinkable} d-flex flex-column flex-grow-1`}>
          <Layout />
        </div>
      </Stack>
    </Page>
  </BlogListProvider>
)
